import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import logo from '../assets/btc_logo2.png';
import { useAuth } from "../contexts/AuthContext";
import Cookies from "js-cookie";
import {isSessionStorageItemExists} from "../utils/functions";

export const Header: React.FC = () => {
    const navigate = useNavigate();
    const { isLoggedIn, logOut, logIn} = useAuth();
    const [headerColor, setHeaderColor] = useState<string>("bg-green-800 text-white shadow-lg");

    // const isLoggedInUser: string | undefined = Cookies.get('username');
    if (isSessionStorageItemExists('userInfo')) logIn();
    const handleLogOut = () => {
        Cookies.remove('username');
        // Clear the session storage
        logOut();
        navigate('/');
    };

    useEffect(() => {
        const mode:string |undefined = process.env.REACT_APP_MODE
        if (mode && mode === 'development'){
            setHeaderColor("bg-blue-800 text-white shadow-lg")
        }
    }, []);

    // State to toggle the mobile menu
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Function to toggle the mobile menu
    const toggleMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };

    const isAdmin = true;

    return (
        <header className={headerColor}>
            <div className="container mx-auto px-4 py-3">
                <div className="flex items-center justify-between">
                    {/* Logo and Branding */}
                    <div className="flex items-center space-x-3">
                        <img
                            src={logo}
                            alt="BTC KYC Portal Logo"
                            className="h-12 w-auto rounded-md border-2 border-white"
                        />
                        <div>
                            <h1 className="text-xl md:text-2xl font-bold tracking-tight">
                                Botswana Telecommunications Corporation
                                <span className="ml-2 inline-flex items-center rounded-md bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 ring-1 ring-inset ring-green-800/20">
                                    BTC Portal  v1.1.3
                                </span>
                            </h1>
                        </div>
                    </div>

                    {/* Desktop Navigation */}
                    {isLoggedIn && (
                        <>
                            <nav className="hidden lg:flex items-center space-x-6">
                                <Link
                                    to="/home"
                                    className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-1.5 px-3 py-2 rounded-md hover:bg-green-700/50"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                    </svg>
                                    <span>Dashboard</span>
                                </Link>

                                <a
                                    href="http://10.1.31.8:3000/"
                                    className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-1.5 px-3 py-2 rounded-md hover:bg-green-700/50"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1v1H9V7zm0 4h1v1H9v-1zm0 4h1v1H9v-1zm4-4h1v1h-1v-1zm0 4h1v1h-1v-1zm0-8h1v1h-1V7zm-4 8h1v1H9v-1zm0 0V5" />
                                    </svg>
                                    <span>Juristic </span>
                                </a>

                                <Link
                                    to="/profile"
                                    className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-1.5 px-3 py-2 rounded-md hover:bg-green-700/50"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    <span>Profile</span>
                                </Link>
                                <Link
                                    to="/"
                                    onClick={handleLogOut}
                                    className="hover:text-red-200 transition-colors duration-200 flex items-center space-x-1.5 px-3 py-2 rounded-md hover:bg-green-700/50"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                    <span>Logout</span>
                                </Link>
                            </nav>

                            {/* Mobile Menu Button */}
                            <button
                                onClick={toggleMenu}
                                className="lg:hidden text-white focus:outline-none p-2 rounded-md hover:bg-green-700/50"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                        </>
                    )}
                </div>

                {/* Mobile Menu */}
                {isLoggedIn && (
                    <div className={`lg:hidden ${isMenuOpen ? "block" : "hidden"} bg-green-900/90 text-white py-2`}>
                        <nav className="flex flex-col space-y-2 px-4">
                            <Link
                                to="/home"
                                className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-3 px-3 py-2 rounded-md hover:bg-green-700/50"
                                onClick={toggleMenu}
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                </svg>
                                <span>Dashboard</span>
                            </Link>

                            <a
                                href="http://10.1.31.8:3000"
                                className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-1.5 px-3 py-2 rounded-md hover:bg-green-700/50"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1v1H9V7zm0 4h1v1H9v-1zm0 4h1v1H9v-1zm4-4h1v1h-1v-1zm0 4h1v1h-1v-1zm0-8h1v1h-1V7zm-4 8h1v1H9v-1zm0 0V5" />
                                </svg>
                                <span>Juristic </span>
                            </a>

                            {isAdmin && (
                                <Link to="/admin" className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-1.5 px-3 py-2 rounded-md hover:bg-green-700/50">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3l7 4v5c0 5-3.5 9.74-7 11-3.5-1.26-7-6-7-11V7l7-4z" />
                                    </svg>
                                    <span>Admin</span>
                                </Link>
                            )}

                            <Link
                                to="/profile"
                                className="hover:text-green-200 transition-colors duration-200 flex items-center space-x-3 px-3 py-2 rounded-md hover:bg-green-700/50"
                                onClick={toggleMenu}
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                <span>Profile</span>
                            </Link>

                            <Link
                                to=""
                                onClick={handleLogOut}
                                className="hover:text-red-200 transition-colors duration-200 flex items-center space-x-3 px-3 py-2 rounded-md hover:bg-green-700/50 text-left"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                <span>Logout</span>
                            </Link>
                        </nav>
                    </div>
                )}
            </div>

            {/* Security Indicator */}
            {isLoggedIn && (
                <div className="bg-green-900 text-green-100 text-xs py-1 px-4 flex justify-between items-center">
                    <div className="flex items-center space-x-2">
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                        </svg>
                        <span>Secure Session</span>
                    </div>
                    <span>Last activity: {new Date().toLocaleTimeString()}</span>
                </div>
            )}
        </header>
    );
};
